module.exports = __webpack_public_path__ + "static/img/report.88a0b98.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/report.png
// module id = /NqX
// module chunks = 1